<template>
  <div class="ht-container">

    <!-- full line -->
    <div class="ht-full-line"></div>

    <!-- items -->
    <div
      v-for="(item, index) in limitedItems"
      :key="index"
      class="ht-item"
    >
      <div
        class="ht-dot"
        :class="item.status"
      >
       <font-awesome-icon :icon="'fa-solid '+item.icon"  /> 
        <!-- <i :class="iconClass(item)"></i> -->
      </div>

      <div class="ht-label">
        <div class="ht-label-line1">{{ item.label.line1 }}</div>
        <div class="ht-label-line2">{{ item.yyyymm }}</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'HorizontalTimeline',
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [
        {
          status: 'active',
          icon: 'fa-check',
          label: { line1: '完成', line2: '2026-02-24' }
        },
         {
          status: 'active',
          icon: 'fa-check',
          label: { line1: '完成', line2: '2026-02-24' }
        },
         {
          status: 'active',
          icon: 'fa-check',
          label: { line1: '完成', line2: '2026-02-24' }
        },
         {
          status: 'active',
          icon: 'fa-check',
          label: { line1: '完成', line2: '2026-02-24' }
        },
         {
          status: 'active',
          icon: 'fa-check',
          label: { line1: '完成', line2: '2026-02-24' }
        },
         {
          status: 'active',
          icon: 'fa-check',
          label: { line1: '完成', line2: '2026-01-24' }
        },
         {
          status: 'active',
          icon: 'fa-check',
          label: { line1: '完成', line2: '2026-02-24' }
        },
        {
          status: 'deny',
          icon: 'fa-times',
          label: { line1: '拒絕', line2: '2026-02-25' }
        },
        {
          status: null,
          icon: 'fa-circle',
          label: { line1: '等待', line2: '2026-02-26' }
        },
        {
          status: null,
          icon: 'fa-circle',
          label: { line1: '等待', line2: '2026-02-26' }
        },
        {
          status: null,
          icon: 'fa-circle',
          label: { line1: '等待', line2: '2026-02-26' }
        },{
          status: null,
          icon: 'fa-circle',
          label: { line1: '等待', line2: '10 Feb 2026' }
        }
      ]
    },
  },
  computed: {
    limitedItems() {
      return this.items.slice(0, 12)
    }
  },
  methods: {
    iconClass(item) {
      // 若 item.icon 有值，用 item.icon
      if (item.icon) return ['fas', item.icon]

      // 否則根據 status 預設
      if (item.status === 'active') return ['fas', 'fa-check']
      if (item.status === 'deny') return ['fas', 'fa-times']
      if (item.status === 'start') return ['fas', 'fa-play']
      return ['fas', 'fa-circle']
    },
  },
}
</script>

<style scoped>
.ht-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding-top: 16px;
}

.ht-item {
  text-align: center;
  flex: 1;
  position: relative;
}

.ht-dot {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  background: #bfbfbf; /* default */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 14px;
}

.ht-dot.active {
  background: #2ecc71;
}

.ht-dot.deny {
  background: #e74c3c;
}

.ht-full-line {
  position: absolute;
  top: 29px;
  left: 0;
  right: 0;
  height: 4px;
  background: #dddddd;
  z-index: 1;
}

.ht-label {
  margin-top: 12px;
}

.ht-label-line1 {
  font-size: 14px;
  font-weight: 600;
}

.ht-label-line2 {
  font-size: 12px;
  opacity: 0.7;
}
</style>
